import { language as store_status_language } from "./store-status";
import { language as lan_addStoreProductModal } from "./add-store-product-modal/index";
import { language as lan_selectStore } from "./select-store/select-store";
import { language as lan_selectStoreProductType } from "./select-store-product-type/select-store-product-type";
import { language as lan_storeProductSetting } from "./store-product-setting/index";
import { language as lan_builderPreview } from "./builder-preview";
import { language as lan_productPriceTable } from "./product-price-table";
import { language as lan_userAuthorize } from "./user-authorize/index";
import { language as lan_userRegist } from "./user-regist/index";
import { language as lan_thirdPartyCpn } from "./third-party-components";
import { language as lan_storeAuthUpdate } from "./store-auth-update/store-auth-update";
import { language as lan_qpMsgDialog } from "./qp-msg-dialog/index";
import { language as lan_qpMsgTooltip } from "./qp-msg-tooltip/index";
import { language as lan_popupbutton } from "./pop-up-button";
import { language as lan_modifyEmail } from "./modify-email";
import { language as lan_preferenceEditor } from "./preference-editor";
import { language as lan_paymentConfirm } from "./payment-confirm";
import { language as lan_photoLibList } from "./photo-lib-list";
import { language as lan_item } from "./store-product-editer/step-editer/product-design/item/index";
import { language as lan_randomDesignEditer } from "./store-product-editer/step-editer/product-design/random-design-editer/index";
import { language as lan_ProductDesignEditer } from "./store-product-editer/step-editer/product-design/index";
import { language as lan_photolibEditer } from "./store-product-editer/step-editer/photolib-editer/index";

let language = {
    ...store_status_language,
    // 添加店铺产品模态框
    ...lan_addStoreProductModal,
    // 选择店铺
    ...lan_selectStore,
    // 选择店铺产品类型
    ...lan_selectStoreProductType,
    // 店铺产品设置
    ...lan_storeProductSetting,
    // builder图片预览
    ...lan_builderPreview,
    // 产品价格列表
    ...lan_productPriceTable,
    // 用户登录
    ...lan_userAuthorize,
    // 用户注册
    ...lan_userRegist,
    // 第三方登录、注册
    ...lan_thirdPartyCpn,
    // shopify店铺授权更新
    ...lan_storeAuthUpdate,
    // qp-message-dialog
    ...lan_qpMsgDialog,
    // qp-msg-tooltip
    ...lan_qpMsgTooltip,
    //弹窗按钮
    ...lan_popupbutton,

    ...lan_modifyEmail,
    // 偏好设置
    ...lan_preferenceEditor,
    // 支付确认
    ...lan_paymentConfirm,
    // 素材库列表
    ...lan_photoLibList,
    //随机规则
    ...lan_randomDesignEditer,
    //随机规则项
    ...lan_item,
    // 店铺产品design
    ...lan_ProductDesignEditer,
    // 素材库编辑
    ...lan_photolibEditer
};


export { language }